/* No `image-rendering` hint here on purpose. cx-resources is a plain static host and ignores the
   ?w=/?h= params in our asset URLs, so every Picture is served at its intrinsic size and downscaled
   by the browser (the header logo: 746x117 -> 213x34). `crisp-edges` / `nearest-neighbor` skip
   interpolation, which drops the averaged pixels that antialiasing depends on and leaves visibly
   jagged edges. Only reintroduce this for pixel-art assets being scaled UP. */
.pictureImage.lazyload {
  visibility: hidden;
}
